import type {
  PROGRAMME_TYPE,
  PROGRAMME_NAME,
  STUDY_MODE,
} from '../../../components/ApplicationForm/constants';

export enum PROGRAMME_CHOICE_DEPARTMENT {
  AP = 'AP',
  ABCT = 'ABCT',
  SFT = 'SFT',
  AF = 'AF',
  MM = 'MM',
  SHTM = 'SHTM',
  CEE = 'CEE',
  BRE = 'BRE',
  BEEE = 'BEEE',
  LSGI = 'LSGI',
  EE = 'EE',
  EIE = 'EIE',
  ME = 'ME',
  LMS = 'LMS',
  ISE = 'ISE',
  BME = 'BME',
  RS = 'RS',
  SO = 'SO',
  SN = 'SN',
  APSS = 'APSS',
  HTI = 'HTI',
  COMP = 'COMP',
  AMA = 'AMA',
  ENGL = 'ENGL',
  CBS = 'CBS',
  SD = 'SD',
  CC = 'CC',
  AAE = 'AAE',
}

export type ProgrammeChoicePartner = {
  university: string;
  proposedChiefSupervisor: string;
  universityCategory: string;
  isPolyUHomeUniversity: boolean;
  physicalLocation: string;
  partnerUniversityApplicationNo?: string; // optional input
};

export type ProgrammeChoice = {
  entryYear: string;
  studyMode: STUDY_MODE;
  department: string;
  programme: PROGRAMME_NAME;
  programmeType: PROGRAMME_TYPE;
  partner: ProgrammeChoicePartner;
  researchArea: string;
  proposedChiefSupervisor: string;
  acceptNoResearchIndicator: boolean;
  researchAreaBackup?: string;
  proposedChiefSupervisorBackup?: string;
};

export type ProgrammeChoiceFormData = {
  programmeChoiceId?: string;
  entryYear: string;
  studyMode: STUDY_MODE | '';
  department: string;
  programme: PROGRAMME_NAME | '';
  programmeType: PROGRAMME_TYPE | '';
  isDualOrCollaborative?: boolean;
  partner: ProgrammeChoicePartner;
  researchArea: string;
  proposedChiefSupervisor: string;
  acceptNoResearchIndicator?: boolean;
  researchAreaBackup?: string;
  proposedChiefSupervisorBackup?: string;
};
